export function formatTenantName(name) {
  return (name ?? '')
    .replace(/[_|\s-]+/g, ' ')
    .trim()
    .toLowerCase()
    .replace(/(^| )\S/g, wordStart => wordStart.toUpperCase())
}
